export default "__VITE_ASSET__BHPdpY7f__"